import { useEffect, useRef, useState } from "react";
import io, { Socket } from "socket.io-client";
import { SOCKET_API_URL } from "../constants/base_url";

interface TranscriptionCompletedData {
  message: string;
  jobId: string;
  status: "COMPLETED";
  duration: number;
  transcriptionCost: number;
  transcript: string;
  timestamp: string;
}

export const useTranscriptionSocket = () => {
  const socketRef = useRef<Socket | null>(null);
  const [transcriptionCompleted, setTranscriptionCompleted] =
    useState<TranscriptionCompletedData | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Initialize socket connection
    const socket = io(SOCKET_API_URL);
    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("Transcription socket connected");
      setIsConnected(true);
    });

    socket.on("disconnect", () => {
      console.log("Transcription socket disconnected");
      setIsConnected(false);
    });

    socket.on("transcription-completed", (data: TranscriptionCompletedData) => {
      console.log("Transcription completed event received:", data);
      setTranscriptionCompleted(data);
    });

    // Cleanup on unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  const clearTranscriptionCompleted = () => {
    setTranscriptionCompleted(null);
  };

  return {
    transcriptionCompleted,
    clearTranscriptionCompleted,
    isConnected
  };
};
